import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  CircularProgress,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
  Alert,
  Button,
  Fab,
} from "@mui/material";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { caseManagementUrl, documentManagementUrl } from "../../../../config";
import { useEffect, useState } from "react";
import { useTheme } from "@mui/material";
import { downloadCaseFile } from "../../../../data/DynamicTable/DynamicFunctions";
import { tokens } from "../../../../theme";
import { CloudUploadIcon } from "lucide-react";
import { UploadDocumentComponent } from "../../../../data/DynamicTable/Modal";
import { CasesColumns, timeTrackerColumns } from "../../../../data/DynamicTable/Collumns";
import { allCasesView, timeTrackerQuery } from "../../../../data/Axios/queries";
import TimeTrackerForm from "./Form";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function TimeTracking() {
  const base_url = caseManagementUrl.uri;

    const location = useLocation();
  
    const navigate = useNavigate();
  
    const caseId = 
      location.state?.caseId ||
      JSON.parse(localStorage.getItem("CaseId"));
  
    const handleGoBack = () => {
      const backPath = location.state?.from || "/Cases";
      navigate(backPath);
    };

  const actions = {
    entity: "Time Tracking",
    isSubRight: true,
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "CreatePermission",
    },
    // viewDocument: {
    //   key: "VIEW_DOCUMENT",
    //   button_name: "Open Document",
    //   Show_Button: true,
    //   permission: "hasNoPermission",
    //   roleGroupId: [1, 2, 3, 4],
    // },
    // documentAccess: {
    //   key: "VIEW_DOCUMENT",
    //   button_name: "Manage Document Permissions",
    //   Show_Button: true,
    //   permission: "hasNoPermission",
    //   roleGroupId: [1, 2, 3, 4],
    // },
    // deleteDocument: {
    //   key: "DELETE_DOCUMENT",
    //   button_name: "Delete Document",
    //   Show_Button: true,
    //   permission: "hasNoPermission",
    //   roleGroupId: [1, 2, 3, 4],
    // },
    dataObject: {
      inputObjectName: "getTimeTrackerById",
      inputSubObjectName: "timeTrackersView",
      inputFields: {
        caseId: caseId,
      },
      returnFields: [
        "id",
        "appliedDate",
        "userAssignedId",
        "assignee",
        "insertedBy",
        "billableItem",
        "description",
        "currency",
        "exchangeRate",
        "timeTakenSeconds",
        "travelHours",
        "otherHours",
        "totalBillableHours",
        "ratePerHour",
        "startTime",
        "stopTime",
        "status",
        "createdBy",
        "createdAt",
        "modifiedBy",
        "updatedat",
      ],
      // isDocumentUplod: true,
    },
    showStatus: true,
  };

  const [dialogOpen, setDialogOpen] = useState(false);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleOpenModal = () => {
    setDialogOpen(true);
  };

  const handleDownload = async () => {
    await downloadCaseFile();
  };

  return (
    <Box m="2px" p="1rem">
      {/* Floating Back Button */}
      <Fab
        color="secondary"
        aria-label="go back"
        onClick={handleGoBack}
        sx={{
          position: "fixed",
          top: 150,      
          left: 290,     
          zIndex: 1100,
          width: 40,
          height: 40,
          boxShadow: 3,
          "&:hover": {
            boxShadow: 6,
          },
        }}
      >
        <ArrowBackIcon />
      </Fab>

      <>
        <Box
          m="2px"
          sx={{
            justifyContent: "end",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Typography
            style={{ color: colors.greenAccent[400], margin: "0 8px" }}
          >
            Import Case File(s)
          </Typography>
          <Button
            variant="contained"
            size="sm"
            sx={{
              backgroundColor: colors.greenAccent[500],
              borderRadius: "4px",
            }}
            component="label"
            role={undefined}
            tabIndex={-1}
            startIcon={<CloudUploadIcon />}
            onClick={handleOpenModal}
          >
            <Typography style={{ color: colors.primary[400], margin: "0 8px" }}>
              Import
            </Typography>
          </Button>
        </Box>
        <DynamicTable
          title="Time Tracking"
          subtitle="View all Time Tracked, create edit or Time Tracking details"
          columns={timeTrackerColumns}
          FormComponent={TimeTrackerForm}
          // query={timeTrackerQuery}
          base_url={base_url}
          actions={actions}
        />
        <UploadDocumentComponent
          uploadType="case"
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
        />
      </>
      {/* //)} */}
    </Box>
  );
}

export default TimeTracking;